require("./transactionHistoryService");

angular.module('app.myProfile.transactionHistory.transactionHistoryController', [
  'app.myProfile.transactionHistory.transactionHistoryService'
])
  .controller('transactionHistoryController', [
    '$scope', 'transactionHistoryService',
    function ($scope, transactionHistory) {
      "use strict";

      $scope.transactionHistory = transactionHistory;

      $scope.pager = {
        current_page: 1,
        page_size: 10,
        items: [],
        pageChanged: function () {
          if (Array.isArray(transactionHistory.list)) {
            let start_index = ($scope.pager.current_page - 1) * $scope.pager.page_size;
            let stop_index = start_index + $scope.pager.page_size;
            $scope.pager.items = transactionHistory.list.slice(start_index, stop_index);
          }
        }
      };

      let init = function () {
        transactionHistory.retrieve();
      };

      $scope.transaction_amount = function (transaction) {
        let unit_amount = parseFloat(transaction.unit_amount_in_cents) / 100;
        let quantity = parseFloat(transaction.quantity);
        let tax = parseFloat(transaction.tax_in_cents) / 100;

        return (quantity * unit_amount) + tax;
      };

      $scope.transaction_discount = function (transaction) {
        return parseFloat(transaction.discount_in_cents) / 100;
      };

      $scope.transaction_total = function (transaction) {
        return $scope.transaction_amount(transaction) + $scope.transaction_discount(transaction);
      };

      $scope.$watch(
        function () {
          return transactionHistory.list;
        },
        function () {
          $scope.pager.current_page = 1;
          $scope.pager.pageChanged();
        }
      );

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/transactionHistory/transactionHistoryController.js